  <template>
    <IndexPage/>
  </template>

<script>
import IndexPage from './components/IndexPage.vue'

export default {
  name: 'App',
  components: {
    IndexPage
  }
}
</script>

<style>
#app {
  width:100%;
  height:100%;
}
</style>
